/** Shared work-item filter shape + DRF param mapping (used by every layout). */
export interface WorkItemFilters {
  search?: string;
  priority?: string;
  state?: number;
  assignee?: number;
  label?: number;
  module?: number;
  cycle?: number;
}

export function filterParams(filters?: WorkItemFilters) {
  return {
    search: filters?.search || undefined,
    priority: filters?.priority || undefined,
    state: filters?.state,
    assignee: filters?.assignee,
    label: filters?.label,
    module: filters?.module,
    cycle: filters?.cycle,
  };
}
